/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

// Polyfills
import 'whatwg-fetch';

// Scripts
// =============================================================================

import PageStatus from './scripts/page-status';
import FAQ from './scripts/faq';
import Header from './scripts/header';
import WhatYouAwaits from './scripts/what-you-awaits';

const scripts = [PageStatus, FAQ, Header, WhatYouAwaits];

document.addEventListener('DOMContentLoaded', () => {
  if (scripts.length > 0 && scripts !== undefined) {
    scripts.forEach(script => {
      script.init();
    });
  }
});

// Vendors
// =============================================================================

import './vendors/smooth-scroll';
